<template>
  <div
      class="share"
      :class="{ 'share--theme-dark': theme === 'dark' }"
  >
    <template v-if="dropdown">
      <b-dropdown
          size="lg"
          :lazy="true"
          variant="transparent"
          :class="{ 'dropdown--theme-dark': theme === 'dark' }"
      >
        <template #button-content>
          {{ label }}
        </template>
        <template v-for="platform in platforms">
          <b-dropdown-item-button
              @click="share(platform)"
              :key="platform"
          >
            <svg class="svg-icon">
              <use :xlink:href="`/app/themes/ahc/src/assets/images/icons.svg#${platform}`"/>
            </svg>
            {{ platform }}
          </b-dropdown-item-button>
        </template>
      </b-dropdown>
    </template>
    <template v-else>
      <p
          v-if="label"
          class="share__info-text"
      >
        {{ label }}
      </p>
      <div v-if="msg" class="share__status" aria-live="polite">{{ msg }}</div>
      <ul
          class="share__list"
          v-if="platforms.length > 0"
      >
        <li
            class="share__list-item"
            v-for="platform in platforms"
            :key="platform"
        >
          <button
              @click="share(platform)"
              class="share__platform"
          >
            <svg class="svg-icon">
              <use :xlink:href="`/app/themes/ahc/src/assets/images/icons.svg#${platform}`"/>
            </svg>
            <span v-if="platform === 'copy'">Copy link to current page.</span>
            <span v-else>Share this page via {{ platform }}</span>
          </button>
        </li>
      </ul>
    </template>
  </div>
</template>

<script lang="js">
import ShareService from './share.service';

export default {
  name: 'AhcShare',
  components: {},
  props: {
    platforms: {
      type: Array,
      default: () => [],
    },
    hashtags: {
      type: Array,
      default: () => [],
    },
    mentions: {
      type: Array,
      default: () => [],
    },
    text: {
      type: String,
      default: '',
    },
    dropdown: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    /**
     * Theme that's either dark or light
     */
    theme: {
      type: String,
      default: 'light',
    },
  },
  data() {
    return {
      shareService: new ShareService(),
      msg: null,
    };
  },
  mounted() {
  },
  methods: {
    share(platform) {
      this.shareService.share(platform, { text: this.text, hashtags: this.hashtags, mentions: this.mentions });
      if (platform === 'copy') {
        this.updateStatus('Planner link copied.');
      }
    },
    updateStatus(msg) {
      this.msg = msg;
      // give message time to display
      // and fade out, then reset
      setTimeout(() => {
        this.msg = null;
      }, 3000);
    },
  },
};
</script>

<style lang="scss">
// only import scss files here if this is a lazy-loaded component.
// otherwise, component scss imports go in components.scss
@import "./share";
</style>
